module.exports = __webpack_public_path__ + "img/PTT.321d66e1.png";